// @mui material components
import { useEffect, useState } from "react";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
// Soft UI Dashboard React examples
import checkboxgreen from "assets/images/logos/checkboxgreen.png";
import checkboxwhite from "assets/images/logos/checkboxwhite.png";
import html2pdf from "html2pdf.js";
import { useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "store/api/api";
import useStore from "store/hook";
import getDateOrTime from "../../services/getDateOrTime";

import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

import brand from "assets/images/logos/image.png";
import { toast } from "react-toastify";
import convertMillisecondsToDate from "services/dateconverter";
import CircularLoader from "components/SoftDialog/Loader";

const Inspectionpdf = () => {
  const { setDialogue, store } = useStore();
  const [isLoading, setIsLoading] = useState(false);
  const [inspectionData, setInspectionData] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [links, setLinks] = useState([]);
  const [manager, setManager] = useState([]);
  const [contacts, setContact] = useState([]);
  const [discipline, setDiscipline] = useState([]);
  const [referenceData, setReferenceData] = useState({});
  const [pdfloading, setPdfLoading] = useState(false);
  const [pfdData, setPdfData] = useState([]);
  const [pdfdata2, setpdfdata2] = useState([]);
  const [imagesDiscipline, setImagesDiscipline] = useState([]);
  const [managerSignature, setManagerSignature] = useState("");
  const [inspectorSignature, setInspectorSignature] = useState("");
  const [deleted, setDeleted] = useState(false);
  const { success } = store?.app?.dialogs?.isSuccess || {};
  const [pdfUrl, setPdfUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [PifNumber, setPifNumber] = useState({
    type: "",
    value: "",
  });
  const [reviewedBy, setReviewBy] = useState(null);
  const [inspectedBy, setInspectedBy] = useState(null);
  const [inspectorData, setInspectorData] = useState({
    name: "",
    image: "",
    id: "",
  });
  let labelCharCode = 65;

  const BASE_URL = process.env.REACT_APP_PROD_URL;
  const { id, token } = useParams();

  const uploadImagesToServer = async (firebaseImageUrls) => {
    try {
      const response = await fetch(`${BASE_URL}/upload-images`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        body: JSON.stringify({ imageUrls: firebaseImageUrls }), // Send the array directly
      });

      // Check for server-side errors

      if (!response.ok) {
        throw new Error(
          `Server error: ${response.status} ${response.statusText}`
        );
      }

      const data = await response.json();
      return data.newImageUrls;
    } catch (error) {
      console.error("Error uploading images:", error);
      return firebaseImageUrls; // Fallback to original URLs if upload fails
    }
  };

  const deleteImagesFromServer = async (deleteImageUrls) => {
    try {
      const response = await fetch(`${BASE_URL}/delete-images`, {
        method: "POST",
        headers: { "Content-Type": "application/json",  authorization: token, },
        body: JSON.stringify({ imagePaths: deleteImageUrls }),
      });

      // Check for server-side errors
      if (!response.ok) {
        throw new Error(
          `Server error: ${response.status} ${response.statusText}`
        );
      }

      const data = await response.json();
      return data.status;
    } catch (error) {
      console.error("Error uploading images:", error);
      return deleteImageUrls; // Fallback to original URLs if upload fails
    }
  };

  const updateDOMWithNewImages = (newImageUrls) => {
    if (!contentRef.current) return;

    // Select only images inside elements with class 'pdf-image'
    const images = contentRef.current.querySelectorAll(".pdf-image");

    images.forEach((img, index) => {
      if (newImageUrls[index]) {
        img.src = newImageUrls[index]; // Update the src attribute
      }
    });
  };

  const updateDOMWithManagerSignature = (newImageUrls) => {
    if (!contentRef.current) return;

    // Select only images inside elements with class 'pdf-image'
    const images = contentRef.current.querySelectorAll(".manager-signature");

    images.forEach((img, index) => {
      if (newImageUrls[index]) {
        img.src = newImageUrls[index]; // Update the src attribute
      }
    });
  };

  const updateDOMWithInspectorSignature = (newImageUrls) => {
    if (!contentRef.current) return;

    // Select only images inside elements with class 'pdf-image'
    const images = contentRef.current.querySelectorAll(".inspector-signature");

    images.forEach((img, index) => {
      if (newImageUrls[index]) {
        img.src = newImageUrls[index]; // Update the src attribute
      }
    });
  };

  const contentRef = useRef(null);

  function sendPdfToIOS(pdfBlob, filename) {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64data = reader.result.split(",")[1];

      if (window.webkit?.messageHandlers?.pdfGenerated) {
        window.webkit.messageHandlers.pdfGenerated.postMessage({
          fileName: filename,
          base64: base64data,
        });
      }
    };

    reader.readAsDataURL(pdfBlob);
  }

  const generatePDF = async (
    DisciplineImages,
    managerSignaturepdf,
    inspectorSignaturepdf,
    projectName,
    inspectionNumber,
    inspectionStartnumber
  ) => {
    if (!contentRef.current) return;
    let deletedImagesArray = [];
    setPdfLoading(true);
    let uploadedManagerSignature = "";
    let uploadedInspectorSignature = "";
    if (DisciplineImages.length > 0) {
      const newImageUrls = await uploadImagesToServer(
        DisciplineImages?.map((item) => item.image)
      );
      if (newImageUrls.length > 0) {
        updateDOMWithNewImages(newImageUrls);
        deletedImagesArray = [...deletedImagesArray, ...newImageUrls];
      }
    }

    if (managerSignaturepdf != "") {
      const uploadManagerSignature = await uploadImagesToServer([
        managerSignaturepdf,
      ]);
      if (uploadManagerSignature.length > 0) {
        updateDOMWithManagerSignature(uploadManagerSignature);
        uploadedManagerSignature = uploadManagerSignature[0];
        deletedImagesArray = [...deletedImagesArray, ...uploadManagerSignature];
      }
    }
    if (inspectorSignaturepdf != "") {
      const uploadInspectorSignature = await uploadImagesToServer([
        inspectorSignaturepdf,
      ]);
      if (uploadInspectorSignature.length > 0) {
        updateDOMWithInspectorSignature(uploadInspectorSignature);
        uploadedInspectorSignature = uploadInspectorSignature[0];
        deletedImagesArray = [
          ...deletedImagesArray,
          ...uploadInspectorSignature,
        ];
      }
    }

    await new Promise((resolve) => setTimeout(resolve, 1000));

    const element = contentRef.current;

    const options = {
      margin: [5, 5, 20, 5],
      filename: `${projectName}  ${inspectionNumber}-${inspectionStartnumber}.pdf`,
      image: { type: "jpeg", quality: 0.7 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["css", "legacy"] },
    };

    await new Promise((resolve) => setTimeout(resolve, 1000));

    const pdf = await html2pdf().from(element).set(options).toPdf().get("pdf");

    const totalPages = pdf.internal.getNumberOfPages();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const filename = `${projectName}  ${inspectionNumber}-${inspectionStartnumber}.pdf`;

    pdf.setPage(1);
    pdf.setFontSize(9); // Reduce font size slightly

    // Positioning
    const leftX = pageWidth / 4;
    const rightX = (3 * pageWidth) / 4;
    const topY = pageHeight - 45; // Move everything up
    const lineOffset = 3; // Adjust line height
    const textOffset = 6; // Adjust text positioning
    const signatureHeight = 14; // Reduce signature image height
    const signatureWidth = 40; // Reduce signature image width

    function getJsPdfImageFormat(url) {
      const extMatch = url.match(/\.(\w+)(?=\?|$)/);
      if (!extMatch) return null;

      const ext = extMatch[1].toLowerCase();
      if (ext === "jpg" || ext === "jpeg") return "JPEG";
      if (ext === "png") return "PNG";
      if (ext === "webp") return "WEBP"; // If using plugin
      return null; // unsupported format
    }

    let managerSignatureFormat = "PNG";
    let inspectorSignatureFormat = "PNG";

    if (uploadedManagerSignature != "") {
      managerSignatureFormat = getJsPdfImageFormat(uploadedManagerSignature);
    }
    if (uploadedInspectorSignature != "") {
      inspectorSignatureFormat = getJsPdfImageFormat(
        uploadedInspectorSignature
      );
    }

    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(9);

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const footerText = [
        "4795 S. Church St. Ext. Suite 2",
        "Roebuck, SC 29376",
        "(864) - 586-6111",
      ];

      footerText.forEach((line, index) => {
        pdf.text(line, pageWidth / 2, pageHeight - 15 + index * 5, {
          align: "center",
        });
      });

      pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 20, pageHeight - 10, {
        align: "right",
      });
    }

    const pdfBlob = pdf.output("blob");
    pdf.save(options.filename);

    sendPdfToIOS(pdfBlob, filename);

    await deleteImagesFromServer(deletedImagesArray);
    setPdfLoading(false);
  };

  const fetchInspectionDetails = async () => {
    try {
      setIsLoading(true);

      const response = await api.getInspectionDetails(
        {
          inspection_id: id,
          is_deleted_needed: true,
        },
        token
      );

      setInspectionData(response.data);
      setInspectorData(
        response?.data?.updated_inspector?._id
          ? {
              name: response?.data?.updated_inspector?.full_name,
              image: response?.data?.updated_inspector?.profile_picture,
              id: response?.data?.updated_inspector?._id,
            }
          : {
              name: response?.data?.added_by?.full_name,
              image: response?.data?.added_by?.profile_picture,
              id: response?.data?.added_by?._id,
            }
      );

      setInspectorSignature(
        response?.data?.updated_inspector?._id
          ? response?.data?.updated_inspector?.signature
          : response.data.added_by?.signature
      );

      setProjectData(response?.data?.projectDetail);
      setLinks(response?.data?.projectDetail?.links);
      setManager(response?.data?.projectDetail?.manager);
      if (response?.data?.projectDetail?.manager) {
        setManagerSignature(
          response?.data?.reviewed_by?._id
            ? response?.data?.reviewed_by?.signature
            : response?.data?.projectDetail?.manager[0].signature
        );
      }
      setContact(response?.data?.projectDetail?.site_contacts);
      setDiscipline(response?.data?.discipline_data);

      if (response?.data?.discipline_data?.length > 0) {
        setImagesDiscipline(
          response?.data?.discipline_data.flatMap((item) => {
            const currentLabel = String.fromCharCode(labelCharCode++);

            return (item.images || []).map((image, index) => ({
              image: image,
              inspectionType: item?.inspectionType,
              label: `${currentLabel}-${index + 1}`,
            }));
          })
        );
      }

      const DisciplineImages = response?.data?.discipline_data.flatMap(
        (item) => {
          const currentLabel = String.fromCharCode(labelCharCode++);

          return (item.images || []).map((image, index) => ({
            image: image,
            inspectionType: item?.inspectionType,
            label: `${currentLabel}-${index + 1}`,
          }));
        }
      );

      const managerSignaturepdf = response?.data?.reviewed_by?._id
        ? response?.data?.reviewed_by?.signature
        : response?.data?.projectDetail?.manager[0].signature;

      const inspectorSignaturepdf = response?.data?.updated_inspector?._id
        ? response?.data?.updated_inspector?.signature
        : response.data.added_by?.signature;

      const projectName = response?.data?.projectDetail?.name;
      const inspectionNumber = response?.data?.inspection_number;
      const inspectionStartnumber = response?.data?.inspection_discipline_start;

      setReferenceData(response?.data?.refferenceData);
      setPifNumber({
        type: response?.data?.pif_type,
        value: response?.data?.pif_value,
      });

      setReviewBy(response?.data?.reviewed_by);
      setInspectedBy(response?.data?.updated_inspector);

      setPdfData([
        {
          name: "Project Name",
          email: response?.data?.projectDetail?.name || "",
          phone: "Project Inspection Form",
          value: ` ${response?.data?.inspection_number}-${response?.data?.inspection_discipline_start}`,
        },
        {
          name: "Location",
          email: response?.data?.projectDetail?.location || "",
          phone: "Project No.",
          value: `#${response?.data?.projectDetail?.project_number}` || "",
        },
      ]);

      setpdfdata2([
        {
          name: "Weather",
          email: response?.data?.weather_condition,
          phone: "Temperature",
          temp: response?.data?.temperature,
        },
        {
          name: "Date",
          email: getDateOrTime(
            convertMillisecondsToDate(response?.data?.inspectionTime, "long"),
            "date"
          ),
          phone: "Time",
          value: getDateOrTime(
            convertMillisecondsToDate(response?.data?.arrival_time),
            "time"
          ),
        },
      ]);

      if (response?.status == 0) {
        toast.error(response?.message);
        setDeleted(true);
      }

      if (response?.status == 7) {
        setDeleted(true);
      }

      await generatePDF(
        DisciplineImages,
        managerSignaturepdf,
        inspectorSignaturepdf,
        projectName,
        inspectionNumber,
        inspectionStartnumber
      );
    } catch (error) {
      toast.error("Internal Server Error");
      toast.error("Oops! Slow network or server issue. Please try again.");
      console.error("Error in fetching details", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInspectionDetails();
  }, []);

  return (
    <>
      {isLoading && (
        <SoftBox
          display="flex"
          height="calc(100vh - 180px)"
          justifyContent="center"
          alignItems="center"
          p={3}
        >
          <SoftTypography variant="subtitle1" color="textSecondary">
            <CircularLoader type="large" />
          </SoftTypography>
        </SoftBox>
      )}

      <SoftBox
        sx={{ display: "none" }}
        width="794px"
        minWidth="794px"
        maxWidth="794px"
      >
        <Container ref={contentRef}>
          {/* Header */}
          <SoftBox display="flex" alignItems="center">
            <SoftBox width="100%" textAlign="center">
              {brand && (
                <SoftBox
                  component="img"
                  src={brand}
                  alt="Soft UI Logo"
                  width="9rem"
                />
              )}
              <SoftTypography
                color="#000000"
                fontSize="8px"
                fontWeight="bold"
                sx={{ lineHeight: "15px" }}
                mt={-2}
              >
                {" "}
                Helping Ensure a Safer Built Environment{" "}
              </SoftTypography>
            </SoftBox>
          </SoftBox>

          {/* pdf data i table */}
          <SoftBox py={1} pt={1}>
            <Table>
              <TableBody>
                {pfdData?.map((contact, index) => (
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{
                        backgroundColor: "#D9D9D9",
                        width: "25%",
                        border: "1px solid #000000",
                        borderBottom: index !== 0 ? "" : "none !important",
                        borderRight: "none !important",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="normal"
                      >
                        {contact.name}{" "}
                      </SoftTypography>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        border: "1px solid #000000",
                        borderBottom: index !== 0 ? "" : "none !important",
                        borderRight: "none !important",
                        borderLeft: "none !important",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="medium"
                      >
                        {contact?.email}{" "}
                      </SoftTypography>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        backgroundColor: "#D9D9D9",
                        borderBottom: index !== 0 ? "" : "none !important",
                        border: "1px solid #000000",
                        borderRight: "none !important",
                        borderLeft: "none !important",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="normal"
                      >
                        {contact?.phone}{" "}
                      </SoftTypography>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        border: "1px solid #000000",
                        borderBottom: index !== 0 ? "" : "none !important",
                        borderLeft: "none !important",
                      }} // Set consistent width
                    >
                      {contact.value && (
                        <SoftTypography
                          sx={{ color: "#000000" }}
                          fontSize="12px"
                          fontWeight="bold"
                        >
                          {contact.value}{" "}
                        </SoftTypography>
                      )}
                      {contact?.temp && (
                        <SoftTypography
                          sx={{ color: "#000000" }}
                          fontSize="12px"
                          fontWeight="bold"
                          display="flex"
                          position="relative"
                        >
                          {contact?.temp}
                          <SoftTypography
                            sx={{ color: "#000000" }}
                            fontSize="12px"
                            fontWeight="bold"
                            display="flex"
                            position="relative"
                          >
                            °F
                          </SoftTypography>
                        </SoftTypography>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </SoftBox>

          {/* pdf data 2 table */}
          <SoftBox py={1} pt={1}>
            <Table>
              <TableBody>
                {pdfdata2?.map((contact, index) => (
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{
                        borderBottom: "none !important",
                        borderRight: "none !important",
                        border: "1px solid #000000",
                        width: "25%",
                        backgroundColor: "#D9D9D9",
                        borderCollapse: "collapse",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="normal"
                      >
                        {contact?.name}{" "}
                      </SoftTypography>
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        borderBottom: "none !important",
                        borderRight: "none !important",
                        borderTop: "1px solid #000000",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="medium"
                      >
                        {contact?.email}{" "}
                      </SoftTypography>
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        backgroundColor: "#D9D9D9",
                        borderRight: "none !important",
                        borderLeft: "none !important",
                        borderBottom: "none !important",
                        border: "1px solid #000000",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="normal"
                      >
                        {contact?.phone}{" "}
                      </SoftTypography>
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        borderBottom: "none !important",
                        borderLeft: "none !important",
                        border: "1px solid #000000",
                      }} // Set consistent width
                    >
                      {contact.value && (
                        <SoftTypography
                          sx={{ color: "#000000" }}
                          fontSize="12px"
                          fontWeight="bold"
                        >
                          {contact.value}{" "}
                        </SoftTypography>
                      )}
                      {contact?.temp && (
                        <SoftTypography
                          sx={{ color: "#000000" }}
                          fontSize="12px"
                          fontWeight="bold"
                          display="flex"
                          position="relative"
                        >
                          {contact?.temp}
                          <SoftTypography
                            sx={{ color: "#000000" }}
                            fontSize="12px"
                            fontWeight="bold"
                            display="flex"
                            position="relative"
                          >
                            °F
                          </SoftTypography>
                        </SoftTypography>
                      )}
                    </TableCell>
                  </TableRow>
                ))}

                <TableCell
                  align="left"
                  sx={{
                    backgroundColor: "#D9D9D9",
                    width: "25%",
                    borderRight: "none !important",
                    border: "1px solid #000000",
                  }} // Set consistent width
                >
                  <SoftTypography
                    sx={{ color: "#000000" }}
                    fontSize="12px"
                    fontWeight="normal"
                  >
                    Deficiencies Found:
                  </SoftTypography>
                </TableCell>

                <TableCell
                  colSpan={3}
                  sx={{
                    paddingTop: 0,
                    paddingBottom: 0,
                    borderLeft: "none !important",
                    border: "1px solid #000000",
                  }}
                >
                  <SoftBox
                    display="flex"
                    alignItems="start"
                    justifyContent="start"
                    gap={6}
                  >
                    <SoftBox
                      display="flex"
                      gap="2px"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <SoftBox position="relative" mt={0.5} mr={0.5}>
                        {inspectionData?.deficiencies_found?.includes("no") ? (
                          <SoftBox
                            component="img"
                            src={checkboxgreen}
                            sx={{
                              width: 15,
                              height: 15,
                              objectFit: "cover",
                              borderRadius: "2px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <SoftBox
                            component="img"
                            src={checkboxwhite}
                            sx={{
                              width: 15,
                              height: 15,
                              objectFit: "cover",
                              borderRadius: "2px",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </SoftBox>

                      <SoftTypography
                        color="lightBlack"
                        fontSize="14px"
                        fontWeight="medium"
                        display="flex"
                        sx={{ color: "#212121" }}
                      >
                        No
                      </SoftTypography>
                    </SoftBox>

                    <SoftBox
                      display="flex"
                      gap="2px"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <SoftBox position="relative" mt={0.5} mr={0.5}>
                        {inspectionData?.deficiencies_found?.includes("yes") ? (
                          <SoftBox
                            component="img"
                            src={checkboxgreen}
                            sx={{
                              width: 15,
                              height: 15,
                              objectFit: "cover",
                              borderRadius: "2px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <SoftBox
                            component="img"
                            src={checkboxwhite}
                            sx={{
                              width: 15,
                              height: 15,
                              objectFit: "cover",
                              borderRadius: "2px",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </SoftBox>

                      <SoftTypography
                        color="lightBlack"
                        fontSize="14px"
                        fontWeight="medium"
                        display="flex"
                        sx={{ color: "#212121" }}
                      >
                        Yes
                        <SoftTypography
                          color="lightBlack"
                          fontSize="14px"
                          fontWeight="regular"
                          display="flex"
                          sx={{ color: "#212121" }}
                        >
                          (see comments below)
                        </SoftTypography>
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </TableCell>
              </TableBody>
            </Table>
          </SoftBox>

          {/* Site Representative */}
          {inspectionData?.app_site_representative?.length > 0 && (
            <SoftBox py={1}>
              <SoftTypography variant="h6" size="14px" fontWeight="bold" py={1}>
                Site Representative
              </SoftTypography>
              <Table
                sx={{
                  tableLayout: "fixed",
                  width: "100%",
                }}
                my={2}
              >
                <TableBody>
                  {inspectionData?.app_site_representative?.length > 0 &&
                    inspectionData?.app_site_representative?.map(
                      (contact, index) => (
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{
                              borderRight: "none !important",
                              border: "1px solid #000000",
                              backgroundColor: "#D9D9D9",
                            }}
                          >
                            <SoftTypography
                              sx={{ color: "#000000" }}
                              fontSize="12px"
                              fontWeight="normal"
                            >
                              Name
                            </SoftTypography>
                          </TableCell>

                          <TableCell
                            align="left"
                            sx={{
                              borderLeft: "none !important",
                              borderRight: "none !important",
                              border: "1px solid #000000",
                            }}
                          >
                            <SoftTypography
                              sx={{ color: "#000000" }}
                              fontSize="12px"
                              fontWeight="normal"
                            >
                              {contact.name}
                            </SoftTypography>
                          </TableCell>

                          <TableCell
                            align="left"
                            sx={{
                              borderLeft: "none !important",
                              borderRight: "none !important",
                              border: "1px solid #000000",
                              backgroundColor: "#D9D9D9",
                            }}
                          >
                            <SoftTypography
                              sx={{ color: "#000000" }}
                              fontSize="12px"
                              fontWeight="normal"
                            >
                              Company Name
                            </SoftTypography>
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              borderLeft: "none !important",
                              border: "1px solid #000000",
                            }}
                          >
                            <SoftTypography
                              sx={{ color: "#000000" }}
                              fontSize="12px"
                              fontWeight="normal"
                            >
                              {contact?.companyName}
                            </SoftTypography>
                          </TableCell>
                        </TableRow>
                      )
                    )}
                </TableBody>
              </Table>
            </SoftBox>
          )}

          {/* ReInspectin Requied */}
          <SoftBox
            display="flex"
            alignItems="start"
            justifyContent="start"
            gap={6}
          >
            <softBox display="flex" alignItems="center" justifyContent="center">
              <SoftTypography
                fontSize="14px"
                fontWeight="medium"
                color="#212121"
                mt={0.4}
              >
                Re-Inspection Required
              </SoftTypography>
            </softBox>

            <SoftBox
              display="flex"
              gap="2px"
              alignItems="center"
              justifyContent="center"
            >
              <SoftBox position="relative" mr={0.5}>
                {inspectionData?.deficiencies_found?.includes(
                  "reinspection_required"
                ) ? (
                  <SoftBox
                    component="img"
                    src={checkboxgreen}
                    sx={{
                      width: 15,
                      height: 15,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <SoftBox
                    component="img"
                    src={checkboxwhite}
                    sx={{
                      width: 15,
                      height: 15,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                  />
                )}
              </SoftBox>

              <SoftTypography
                color="lightBlack"
                fontSize="14px"
                fontWeight="medium"
                display="flex"
                sx={{ color: "#212121" }}
              >
                Yes
              </SoftTypography>
            </SoftBox>

            <SoftBox
              display="flex"
              gap="2px"
              alignItems="center"
              justifyContent="center"
            >
              <SoftBox position="relative" mr={0.5}>
                {!inspectionData?.deficiencies_found?.includes(
                  "reinspection_required"
                ) ? (
                  <SoftBox
                    component="img"
                    src={checkboxgreen}
                    sx={{
                      width: 15,
                      height: 15,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <SoftBox
                    component="img"
                    src={checkboxwhite}
                    sx={{
                      width: 15,
                      height: 15,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                  />
                )}
              </SoftBox>

              <SoftTypography
                color="lightBlack"
                fontSize="14px"
                fontWeight="medium"
                display="flex"
                sx={{ color: "#212121" }}
              >
                No
              </SoftTypography>
            </SoftBox>
          </SoftBox>

          {/* Disciplinne section */}

          {discipline?.length > 0 &&
            discipline?.map((disciplineData, index) => (
              <>
                <SoftBox>
                  <SoftTypography
                    variant="h6"
                    fontSize="18px"
                    fontWeight="bold"
                  >
                    {discipline?.length > 1 &&
                      `${String.fromCharCode(65 + index)})`}{" "}
                    Discipline : {disciplineData?.disciplineName}
                  </SoftTypography>
                </SoftBox>

                {disciplineData?.inspectionType && (
                  <SoftBox
                    sx={{ breakInside: "auto", pageBreakInside: "auto" }}
                  >
                    <SoftTypography
                      fontSize="14px"
                      fontWeight="regular"
                      color="#212121"
                      sx={{ breakInside: "auto", pageBreakInside: "auto" }}
                    >
                      <strong fontWeight="medium"> Inspection Type : </strong>{" "}
                      {disciplineData?.inspectionType}
                    </SoftTypography>
                  </SoftBox>
                )}

                {disciplineData?.location && (
                  <SoftBox
                    sx={{ breakInside: "auto", pageBreakInside: "auto" }}
                  >
                    <SoftTypography
                      fontSize="14px"
                      fontWeight="regular"
                      color="#212121"
                      sx={{ breakInside: "auto", pageBreakInside: "auto" }}
                    >
                      <strong fontWeight="medium"> Location : </strong>
                      {disciplineData?.location}
                    </SoftTypography>
                  </SoftBox>
                )}

                {disciplineData?.comment && (
                  <SoftBox
                    sx={{
                      breakInside: "auto",
                      pageBreakInside: "auto !important",
                      pageBreakBefore: "auto  !important",
                      pageBreakAfter: "auto  !important",
                      display: "block",
                    }}
                  >
                    {disciplineData.comment
                      .split("\n")
                      .map((comment, index) => (
                        <SoftTypography
                          key={index}
                          fontSize="14px"
                          fontWeight="regular"
                          sx={{
                            breakInside: "avoid",
                            pageBreakInside: "avoid !important",
                            pageBreakBefore: "avoid  !important",
                            pageBreakAfter: "avoid  !important",
                            display: "block",
                            whiteSpace: "pre-line",
                          }}
                          color="#212121"
                        >
                          {index == 0 && (
                            <strong fontWeight="medium"> Comments : </strong>
                          )}

                          {comment}
                        </SoftTypography>
                      ))}
                  </SoftBox>
                )}

                {PifNumber?.type && (
                  <SoftBox display="flex" gap={0.5}>
                    <SoftTypography
                      fontSize="14px"
                      fontWeight="bold"
                      color="#212121"
                      sx={{
                        breakInside: "avoid",
                        pageBreakInside: "avoid !important",
                        pageBreakBefore: "avoid  !important",
                        pageBreakAfter: "avoid  !important",
                        display: "inline-block",
                      }}
                    >
                      {PifNumber?.type == "corrected_pif"
                        ? "PIF Corrected Number :"
                        : "PIF Replace Number :"}
                    </SoftTypography>

                    <SoftBox backgroundColor="#F8FE01" px={4}>
                      <SoftTypography
                        fontSize="14px"
                        fontWeight="regular"
                        color="#212121"
                        sx={{
                          breakInside: "avoid",
                          pageBreakInside: "avoid !important",
                          pageBreakBefore: "avoid  !important",
                          pageBreakAfter: "avoid  !important",
                          display: "inline-block",
                        }}
                      >
                        {PifNumber?.value}
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                )}

                {disciplineData?.notes && (
                  <SoftBox
                    sx={{
                      breakInside: "avoid",
                      pageBreakInside: "avoid !important",
                      pageBreakBefore: "avoid  !important",
                      pageBreakAfter: "avoid  !important",
                      display: "block",
                    }}
                  >
                    {disciplineData.notes.split("\n").map((note, index) => (
                      <SoftTypography
                        key={index}
                        fontSize="14px"
                        fontWeight="regular"
                        sx={{
                          breakInside: "avoid",
                          pageBreakInside: "avoid !important",
                          pageBreakBefore: "avoid  !important",
                          pageBreakAfter: "avoid  !important",
                          display: "block",
                          whiteSpace: "pre-line",
                        }}
                        color="#212121"
                      >
                        {index == 0 && (
                          <strong fontWeight="medium"> Notes : </strong>
                        )}

                        {note}
                      </SoftTypography>
                    ))}
                  </SoftBox>
                )}

                {/* Line  */}
                <SoftBox border="1px solid #212121" width="100%" my={1}>
                  {" "}
                </SoftBox>
              </>
            ))}

          {/* Signature Footer */}

          <SoftBox
            display="inline-block"
            width="100%"
            sx={{
              breakInside: "avoid",
              pageBreakInside: "avoid !important",
              pageBreakBefore: "avoid  !important",
              pageBreakAfter: "avoid  !important",
            }}
          >
            <SoftBox
              display="flex"
              width="100%"
              gap={3}
              sx={{
                breakInside: "avoid",
                pageBreakInside: "avoid !important",
                pageBreakBefore: "avoid  !important",
                pageBreakAfter: "avoid  !important",
              }}
            >
              {/* left box */}

              <SoftBox
                width="100%"
                display="flex"
                flexDirection="column"
                gap={1}
              >
                {/* Top */}
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SoftBox
                    display="inline-block"
                    sx={{
                      breakInside: "avoid",
                      pageBreakInside: "avoid",
                      pageBreakBefore: "avoid",
                      pageBreakAfter: "avoid",
                    }}
                  >
                    <SoftTypography
                      fontSize="14px"
                      fontWeight="medium"
                      color="#212121"
                    >
                      {" "}
                      {reviewedBy?._id
                        ? reviewedBy?.full_name
                        : manager?.[0]?.full_name}
                    </SoftTypography>
                  </SoftBox>

                  <SoftBox border="1px solid #212121" width="100%">
                    {" "}
                  </SoftBox>
                  <SoftTypography
                    fontSize="10px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    (Reviewed By - Printed Name){" "}
                  </SoftTypography>
                </SoftBox>

                {/* Bottom */}
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SoftBox
                    className="manager-signature"
                    component="img"
                    src={managerSignature}
                    alt={`Signature Image`}
                    sx={{
                      width: "30%",
                      height: "80px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                  <SoftBox border="1px solid #212121" width="100%">
                    {" "}
                  </SoftBox>
                  <SoftTypography
                    fontSize="10px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    (Reviewed By - Signature){" "}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>

              {/* Right block   */}
              <SoftBox
                width="100%"
                display="flex"
                gap={1}
                flexDirection="column"
              >
                {/* Top */}
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SoftTypography
                    fontSize="14px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    {inspectedBy?._id
                      ? inspectedBy?.full_name
                      : inspectionData?.added_by?.full_name}
                  </SoftTypography>
                  <SoftBox border="1px solid #212121" width="100%">
                    {" "}
                  </SoftBox>
                  <SoftTypography
                    fontSize="10px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    (Inspected By - Printed Name){" "}
                  </SoftTypography>
                </SoftBox>

                {/* Bottom */}
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SoftBox
                    className="inspector-signature"
                    component="img"
                    src={inspectorSignature}
                    alt={`Signature Image`}
                    sx={{
                      width: "30%",
                      height: "80px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                  <SoftBox border="1px solid #212121" width="100%">
                    {" "}
                  </SoftBox>
                  <SoftTypography
                    fontSize="10px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    (Inspected By - Signature){" "}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>

          <SoftBox sx={{}}>
            {imagesDiscipline.length > 0 &&
              imagesDiscipline.map((item, index) => (
                <>
                  <SoftBox
                    key={index}
                    sx={{
                      width: "188mm", // A4 width
                      height: "260mm", // A4 height
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "start",
                      overflow: "hidden",
                      pageBreakBefore: "always",
                      pageBreakInside: "avoid",
                      breakInside: "avoid",
                      gap: 1,
                    }}
                  >
                    <SoftBox display="flex" gap={1}>
                      <SoftTypography
                        variant="h6"
                        fontSize="18px"
                        fontWeight="bold"
                        sx={{
                          whiteSpace: "nowrap",
                        }}
                        gap={1}
                      >
                        {discipline?.length > 1 && `${item?.label})`}{" "}
                        {discipline[0]?.disciplineName} :{" "}
                      </SoftTypography>

                      <SoftTypography
                        variant="h6"
                        fontSize="18px"
                        fontWeight="normal"
                      >
                        {" "}
                        {item?.inspectionType}{" "}
                      </SoftTypography>
                    </SoftBox>

                    <SoftBox
                      component="img"
                      className="pdf-image"
                      src={item?.image}
                      alt={`Discipline Image ${index}`}
                      sx={{
                        maxWidth: "90%",
                        maxHeight: "90%",
                        minHeight: "900px",
                        minWidth: "800px ",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  </SoftBox>
                </>
              ))}
          </SoftBox>
        </Container>
      </SoftBox>
    </>
  );
};

export default Inspectionpdf;
